const AUTH_TYPES = {
	LOGIN: 'AUTH/LOGIN',
	LOGOUT: 'AUTH/LOGOUT',
	SUCCESS_LOGIN: 'AUTH/SUCCESS_LOGIN',
	LOGIN_FAILED: 'AUTH/LOGIN_FAILED',
	ME: 'AUTH/ME',
};

export default AUTH_TYPES;
